// AI Generated Component
import { Component, Input } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { SessionService } from '@monsido/core/session/session.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { MON_MODULES } from '@monsido/core/constants/mon-modules.constant';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'form-user-access',
    templateUrl: './access.component.html',
    standalone: false,
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class FormUserAccessComponent {
    @Input() user: any;

    modules: any[] = [];
    allChecked = false;

    constructor (
        private translateService: TranslateService,
        private sessionService: SessionService,
        private activeFeatureService: ActiveFeatureService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.modules = [
            {
                name: this.translateService.getString('Content Policies'),
                module: MON_MODULES.policies,
            },
            {
                name: this.translateService.getString('Content Quality'),
                module: MON_MODULES.qa,
            },
            {
                name: this.translateService.getString('Accessibility'),
                module: MON_MODULES.accessibility,
            },
            {
                name: this.translateService.getString('SEO Issues'),
                module: MON_MODULES.seo,
            },
            {
                name: this.translateService.getString('Site Inventory'),
                module: MON_MODULES.inventory,
            },
            {
                name: this.translateService.getString('Site Analytics'),
                module: MON_MODULES.statistics,
            },
            {
                name: this.translateService.getString('Prioritized Pages'),
                module: MON_MODULES.content_pages,
            },
            {
                name: this.translateService.getString('Performance Scans'),
                module: MON_MODULES.performance,
            },
        ];

        if (this.sessionService.customer?.plan_traits.heartbeat) {
            this.modules.splice(4, 0, {
                name: this.translateService.getString('Uptime Monitoring'),
                module: MON_MODULES.uptime,
            });
        }

        if (this.activeFeatureService.isFeatureActive('admin_page_fix')) {
            this.modules.splice(4, 0, {
                name: this.translateService.getString('PageCorrect'),
                module: MON_MODULES.pagecorrect,
            });
        }

        if (this.activeFeatureService.isFeatureActive('admin_data_privacy')) {
            this.modules.push({
                name: this.translateService.getString('Data Privacy'),
                module: MON_MODULES.data_privacy,
            });
        }

        this.user.settings = this.user.settings || { modules: [] };
        this.areAllChecked();

        this.modules.forEach((module) => {
            module.value = this.user.settings.modules.indexOf(module.module) === -1;
        });
    }

    onCheck () {
        setTimeout(() => {
            this.user.settings.modules = this.modules
                .filter((module) => !module.value)
                .map((module) => module.module);
            this.areAllChecked();
        });
    }

    areAllChecked () {
        this.allChecked = this.user.settings.modules.length === 0;
    }

    setAllChecked () {
        setTimeout(() => {
            this.modules.map((module) => {
                module.value = this.allChecked;
                return module;
            });
            this.onCheck();
        });
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }
}
